/*
 * Author profile — chip placement on phones.
 *
 * Below 750px the photo and the chip list form a floated left column with the
 * description running beside them. That is right while the description is the
 * taller of the two, but when an author has a short bio and a long chip list
 * the chips carry on alone down the left and leave the right half empty.
 *
 * CSS cannot choose between the two, because neither floats nor grid can react
 * to a sibling's height. So measure once and set a class:
 *
 *   default                      chips beside the description (left column)
 *   .author-profile__header--chips-below
 *                                chips moved after the description, full width
 *                                and two to a row
 *
 * Only the header of the author-profile section is touched, and only under
 * 750px — every other breakpoint keeps the grid untouched.
 */
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.author-profile__header');
  if (!header) return;

  const photo = header.querySelector('.author-profile__photo-wrap');
  const aside = header.querySelector('.author-profile__tags-aside');
  const intro = header.querySelector('.author-profile__intro');
  if (!photo || !aside || !intro) return;

  const BELOW = 'author-profile__header--chips-below';
  const mobile = window.matchMedia('(max-width: 749px)');

  const place = () => {
    if (!mobile.matches) {
      header.classList.remove(BELOW);
      if (aside.nextElementSibling !== intro) header.insertBefore(aside, intro);
      return;
    }

    // Measure the chip column as it stands in the left gutter: one chip per
    // row at the photo's width.
    header.classList.remove(BELOW);
    if (aside.nextElementSibling !== intro) header.insertBefore(aside, intro);

    const photoStyles = window.getComputedStyle(photo);
    const columnHeight =
      photo.offsetHeight + parseFloat(photoStyles.marginBottom || 0) + aside.offsetHeight;

    // Then measure the description with only the photo beside it, which is
    // how tall it would be if the chips moved out of its way.
    header.classList.add(BELOW);
    header.appendChild(aside);
    const descriptionHeight = intro.offsetHeight;

    // Keep the chips beside the description whenever the description is the
    // taller column — that is the layout with no wasted space.
    if (columnHeight <= descriptionHeight) {
      header.classList.remove(BELOW);
      header.insertBefore(aside, intro);
    }
  };

  place();

  // Text metrics shift once the webfont lands, so re-run when it does.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);

  let pending;
  window.addEventListener('resize', function () {
    window.clearTimeout(pending);
    pending = window.setTimeout(place, 150);
  });
});
